/** Shell elements made unreachable while a routed entity dialog is open. */
export const ENTITY_DIALOG_INERT_SELECTORS = [
  '.shell-content > router-outlet ~ *:not(entity-dialog-host):not(entity-inspector-host)',
  'side-nav',
  'inline-side-nav',
  '.shell-top',
] as const;
